import { Edit, Trash } from '@styled-icons/boxicons-solid'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'
import { useState } from 'react'

const VisualAidRow = (props) => {
  const [visualRowId, setVisualRowId] = useState(null)

  return (
    <>
      <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
        <div className="flex flex-row w-full">
          <div className="flex w-3/12 items-center">
            <Tooltip message={props.name}>
              <div>{formatEmptyValue(props?.name)}</div>
            </Tooltip>
          </div>
          <div className="flex w-2/12 pl-6 items-center table_text">
            <Tooltip message={props.code}>
              <div>{formatEmptyValue(props?.code)}</div>
            </Tooltip>
          </div>
          <div className="flex w-1/12 pl-6 items-center table_text">
            <Tooltip message={props.aid_type}>
              <div>{formatEmptyValue(props.aid_type)}</div>
            </Tooltip>
          </div>
          <div className="flex w-4/12 pl-6 items-center table_text">
            <Tooltip message={props.visual_aid_file_name}>
              <div
                className="underline"
                onClick={() => props.downloadVisualAidFile()}
              >
                {formatEmptyValue(props.visual_aid_file_name)}
              </div>
            </Tooltip>
          </div>
          <div className="flex w-2/12 pl-6 justify-end items-center">
            <div>
              <span
                onClick={() => {
                  visualRowId && props.id == visualRowId
                    ? setVisualRowId(null)
                    : setVisualRowId(props.id)
                }}
                className="cursor-pointer p-2 text-blue-600 underline"
              >
                Action
              </span>
            </div>
            <div>
              <span
                onClick={() => {
                  props.onShowDetails()
                }}
                className="cursor-pointer p-2"
              >
                <Edit size="2rem" color="#0189E9" />
              </span>
            </div>
            <div>
              <span
                onClick={() => {
                  props.onDelete()
                }}
                className="cursor-pointer p-2"
              >
                <Trash size="2rem" color="#0189E9" />
              </span>
            </div>
          </div>
        </div>
      </div>
      {visualRowId === props.id && (
        <div className="flex flex-row items-center bg-white border-b py-2 px-3 w-full">
          <div className="w-full">
            <div className="font-bold">Sales Code</div>
            <div>
              {props.sales_codes_data?.map((item) => item.label).join(',')}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default VisualAidRow
